

import {
  useState,
  useEffect,
  JSXElementConstructor,
  Key,
  ReactElement,
} from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";


import routes from "../../routes";

//  contexts
import { useMaterialUIController } from "context";

import { ConfirmDialogProvider } from "components/ConfirmDialog";
import { buildTestSearchString } from "utils/urlParams.util";

export default function App() {
  const [controller, ] = useMaterialUIController();
  const { direction } = controller;
  const [isUserAssosiated] = useState(false);
  const { pathname, search } = useLocation();

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes: any[], isUserAssosiated: boolean): any => {
    return allRoutes.map(
      (route: {
        collapse: any;
        route: string;
        component: ReactElement<any, string | JSXElementConstructor<any>>;
        key: Key;
        shouldBeAssosiated?: boolean;
      }) => {
        if (
          (route.route && !route.shouldBeAssosiated) ||
          (route.route && route.shouldBeAssosiated && isUserAssosiated)
        ) {
          return (
            <Route
              path={route.route}
              element={route.component}
              key={route.key}
            />
          );
        }

        return null;
      }
    );
  };

  return (
    <ConfirmDialogProvider>
      <Routes>
        {getRoutes(routes, isUserAssosiated)}
        <Route path="*" element={<Navigate to={{ pathname: "/landing", search: buildTestSearchString(search) }} replace />} />
      </Routes>
    </ConfirmDialogProvider>
  );
}
